module.exports = __webpack_public_path__ + "img/fushimi-HP-009.33bc167d.jpg";